import type React from 'react';

export interface DiscrepancyIndicatorProps {
  /** Mensagens visíveis ao atendente primário. */
  attendantSees: number;
  /** Mensagens visíveis ao supervisor (mediator). */
  supervisorSees: number;
  /** Diferença real do backend (supervisorVisibleCount − attendantVisibleCount). */
  discrepancyCount: number;
}

/**
 * DiscrepancyIndicator (D7) — só em Bond adversarial (Regulated). Mostra que o
 * supervisor (mediator) vê mensagens que o atendente NÃO vê (filtro adversarial
 * respeitado). Não renderiza quando a diferença é ≤0 (regra do silêncio).
 *
 * Convertido verbatim de design-references/brief-3/shared/badges-3.jsx:256-267
 * (a prop `diff` do mockup vira o `discrepancyCount` real do backend).
 */
export function DiscrepancyIndicator({
  attendantSees,
  supervisorSees,
  discrepancyCount,
}: DiscrepancyIndicatorProps): React.JSX.Element | null {
  if (discrepancyCount <= 0) return null;
  return (
    <div className="discrepancy-ind">
      <div className="discrepancy-ind__head">⚠ Discrepância de visibilidade</div>
      <div className="discrepancy-ind__row">
        <span>Atendente vê</span>
        <b>{attendantSees} mensagens</b>
      </div>
      <div className="discrepancy-ind__row">
        <span>Você vê</span>
        <b>{supervisorSees} mensagens</b>
      </div>
      <div className="discrepancy-ind__note">
        {discrepancyCount} mensagens visíveis apenas para você (mediator role) · filtro adversarial
        respeitado ✓
      </div>
    </div>
  );
}
